var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubstitution(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 18.6117C50 18.6117 50 27.7027 50 27.7027V32.2481H35V27.7027C35 27.7027 35 23.8617 32.125 20.4299C31.7 19.9072 31.175 19.4072 30.625 18.9299C31.925 18.7481 33.35 18.6117 35 18.6117ZM0 27.7027C0 27.7027 0 18.6117 15 18.6117C30 18.6117 30 27.7027 30 27.7027V32.2481H0V27.7027ZM17.5 36.7936V41.339H32.5V36.7936L40 43.6117L32.5 50.4299V45.8845H17.5V50.4299L10 43.6117L17.5 36.7936ZM15 0.429932C10.85 0.429932 7.5 3.47539 7.5 7.24811C7.5 11.0208 10.85 14.0663 15 14.0663C19.15 14.0663 22.5 11.0208 22.5 7.24811C22.5 3.47539 19.15 0.429932 15 0.429932ZM35 0.429932C30.85 0.429932 27.5 3.47539 27.5 7.24811C27.5 11.0208 30.85 14.0663 35 14.0663C39.15 14.0663 42.5 11.0208 42.5 7.24811C42.5 3.47539 39.15 0.429932 35 0.429932Z",
    fill: "#323232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubstitution);
export default __webpack_public_path__ + "static/media/substitution.f9df0d4acece021bf3943be36252e04b.svg";
export { ForwardRef as ReactComponent };